export default {
  user: null,
  idNo: null,
  token: null,
  phone: null,
  routeView: false,
  services: [],
  oldPassword: null,
  confirmToken: null,
  changePassword: false,
  loading: false,
  info: {show: false, message: ""},
  error: {show: false, message: ""},
  activeCounty: {}
};



// WEBPACK FOOTER //
// ./src/store/state.js